import { createContext } from 'react';
import { GetPersonsAccountsParams } from '@goldwasserexchange/actor/rest-services';

export const personAccountsParamsContext = createContext<Partial<GetPersonsAccountsParams>>({});
